import React, { useEffect, useRef, useState } from "react";
import LoginPhoto from "../assets/images/پارا.png";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getRefreshToken } from "../store/login";
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa6";
import DOMPurify from "dompurify";

const LoginPage = () => {
  const passwordRef = useRef(null);
  const usernameRef = useRef(null);
  const isLoggedIn = useSelector((state) => state.login.accessToken);
  const loginError = useSelector((state) => state.login.refreshError);
  const [passwordShown, setPasswordShown] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const sanitizeInput = (input) => {
    return DOMPurify.sanitize(input);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const username = sanitizeInput(usernameRef.current.value);
    const password = sanitizeInput(passwordRef.current.value);

    dispatch(getRefreshToken({ username, password }));
  };

  useEffect(() => {
    if (isLoggedIn) {
      navigate("/payesh");
    }
  }, [isLoggedIn]);

  const togglePasswordVisibility = () => {
    setPasswordShown((passwordShown) => !passwordShown);
  };

  return (
    <div className="container my-md-5 py-5">
      <div className="row my-md-5 py-5">
        <div className="col-md-6 offset-md-3 mx-auto my-md-5">
          <div className="card my-5">
            <form
              className="card-body cardbody-color p-lg-5"
              onSubmit={handleSubmit}
            >
              <div className="text-center">
                <img
                  src={LoginPhoto}
                  className="img-fluid profile-image-pic img-thumbnail border-0 my-3"
                  width="200px"
                  alt="profile"
                />
              </div>

              {loginError ? (
                <div className="mx-auto mb-5">
                  <h6 className="text-danger">
                    * نام کاربری یا رمز عبور اشتباه است
                  </h6>
                </div>
              ) : (
                ""
              )}

              <div className="mb-4">
                <input
                  ref={usernameRef}
                  type="text"
                  className="form-control"
                  id="Username"
                  placeholder="نام کاربری"
                />
              </div>

              <div
                className="input-group mb-4"
                style={{ position: "relative" }}
              >
                <input
                  ref={passwordRef}
                  type={passwordShown ? "text" : "password"}
                  className="form-control"
                  id="password"
                  placeholder="رمز عبور"
                />
                <div
                  className="input-group-append"
                  style={{
                    position: "absolute",
                    left: "0",
                    top: "0",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <span
                    className="input-group-text"
                    style={{ background: "none", border: "none" }}
                  >
                    {!passwordShown ? (
                      <FaEye
                        onClick={togglePasswordVisibility}
                        style={{ cursor: "pointer" }}
                      />
                    ) : (
                      <FaEyeSlash
                        onClick={togglePasswordVisibility}
                        style={{ cursor: "pointer" }}
                      />
                    )}
                  </span>
                </div>
              </div>

              <div className="text-center">
                <button
                  type="submit"
                  className="btn btn-success py-2 px-4 mb-5"
                >
                  ورود
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
